import React, { useEffect, useState } from "react";
import { SectionText } from "../../components/SectionText/SectionText";
import { RangeSlider } from "../../components/RangeSlider/RangeSlider";
import { Button } from "../../components/Button/Button";
import { Form } from "../../templates/Form/Form";
import { Simulation } from "../../hooks/simulationData";
import { formatPercentage, isTableOccasional } from "../../helpers/Pipes";
import { Modal } from "../../components/Modal/Modal";
import iconDownArrow from "../../assets/images/icon--arrow-down.png";
import Select from "react-select";
import { components } from "react-select";
import { Icon } from "../../components/Icon/Icon";
import { chipsGroupDefault } from "../../helpers/utils";

export const MultiRange = ({
    customClasses,
    sommaMinValue,
    sommaMaxValue,
    sommaDefaultValue,
    sommaMinValueLabel,
    sommaMaxValueLabel,
    sommaStep,

    rataMinValue,
    rataMaxValue,
    rataDefaultValue,
    rataMinValueLabel,
    rataMaxValueLabel,
    rataStep,

    rataDefaultValueLabel,

    onImportoChange,
    onRataChange,
    onSubmit,
}) => {
    const [isModalMoreInfoActive, setIsModalMoreInfoActive] = useState(false);
    const { SingleValue, Option, DropdownIndicator } = components;
    const [purposeOptions, setPurposeOptions] = useState([]);
    const [purposeValue, setPurposeValue] = useState({});

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            outline: "none",
            appearance: "none",
            marginTop: "1px",
            paddingTop: "0px",
            paddingBottom: "0px",
            borderRadius: "15px",
            overflow: "hidden",
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            top: "13px",
        }),
        menuList: (provided) => ({
            ...provided,
            marginTop: "0px",
            paddingTop: "0px",
            paddingBottom: "0px",
            maxHeight: "180px",
        }),
        option: (provided, { isFocused, isSelected }) => ({
            ...provided,
            backgroundColor: isFocused ? "transparent" : isSelected ? "transparent" : "transparent",
            color: "inherit",
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            display: "none",
        }),
        singleValue: (provided) => ({
            ...provided,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            outline: "transparent",
        }),
        control: (provided, state) => ({
            ...provided,
            borderRadius: "15px",
            outline: "transparent",
            border: state.isFocused ? "1px solid var(--red)" : "1px solid #cccccc",
            boxShadow: "none",
        }),
    };
    const IconSingleValue = (props) => (
        <SingleValue {...props}>
            <Icon setViewBox="yes" name={props.data.image} illustration={true} />
            {props.data.label}
        </SingleValue>
    );
    const IconOption = (props) => (
        <Option {...props}>
            <div className="reactSelectIconOption">
                <Icon setViewBox="yes" name={props.data.image} illustration={true} />
                <div>{props.data.label}</div>
            </div>
        </Option>
    );
    const CustomDropdownIndicator = (props) => (
        <DropdownIndicator {...props}>
            <img style={{ top: "13px" }} className="custom-select__caret" src={iconDownArrow} alt="" />
        </DropdownIndicator>
    );

    useEffect(() => {
        const options = chipsGroupDefault.map((itm, idx) => {
            return {
                label: itm.title,
                value: itm.id,
                image: itm.iconName,
            };
        });
        setPurposeOptions(options);
        
        setPurposeValue(Simulation.get("purposeSelectValue") || options[0]);
    }, []);

    const handleCloseModal = () => {
        setIsModalMoreInfoActive(false);
    };

    function handleRangeCalculation(event) {
        event.preventDefault();

        if (onSubmit) {
            onSubmit(event);
        }
    }

    const onPurposeSelectionChange = (id) => {
        const selectedPurpose = chipsGroupDefault.filter((_) => _.id == id)[0];
        setPurposeValue(purposeOptions.filter((_) => _.value == id)[0]);
        Simulation.set("purposeSelectValue", purposeOptions.filter((_) => _.value == id)[0]);
        Simulation.set("purpose", selectedPurpose.id);
        Simulation.set("purposeIconName", selectedPurpose.iconName);
        Simulation.set("purposeCode", selectedPurpose.cod);
        Simulation.set("purposeTitle", selectedPurpose.title);
    };

    return (
        <section className={["multi-range", customClasses].join(" ")}>
            <Form onSubmit={(event) => handleRangeCalculation(event)}>
                <SectionText hideTitle="yes" hideText="no" textLabel="Di quale somma hai bisogno?" customClasses="mBottom7x --bigger-text" />

                <RangeSlider
                    customClasses="mBottom4x"
                    name="somma"
                    minValue={sommaMinValue}
                    minValueLabel={sommaMinValueLabel}
                    maxValue={sommaMaxValue}
                    maxValueLabel={sommaMaxValueLabel}
                    defaultValue={sommaDefaultValue}
                    step={sommaStep}
                    onChange={(e) => onImportoChange(e.target.value)}
                    id="somma-range"
                />

                <SectionText hideTitle="yes" hideText="no" textLabel="Quale rata mensile è comoda per te?" customClasses="mBottom7x --bigger-text" />

                <RangeSlider
                    customClasses="mBottom5x"
                    name="rata"
                    minValue={rataMinValue}
                    minValueLabel={rataMinValueLabel}
                    maxValue={rataMaxValue}
                    maxValueLabel={rataMaxValueLabel}
                    defaultValue={rataDefaultValue}
                    step={rataStep}
                    onChange={(e) => onRataChange(e.target.value)}
                    id="rata-range"
                    rataDefaultValueLabel={rataDefaultValueLabel}
                />

                {/* scelta obiettivo */}
                <div>
                    <section className="section-text mBottom1x --bigger-text ">
                        <p className="text">Qual è l'obiettivo del prestito?</p>
                    </section>
                    <div className="custom-select__container mBottom4x">                        
                        <Select
                            id="purpose-select"
                            className="purpose-select"
                            isSearchable={false}
                            // value={purposeValue}
                            value={Simulation.get("purposeSelectValue") || purposeValue}
                            styles={customStyles}
                            components={{ Option: IconOption, SingleValue: IconSingleValue, DropdownIndicator: CustomDropdownIndicator }}
                            options={purposeOptions}
                            onChange={(purposeObject) => {
                                onPurposeSelectionChange(purposeObject.value);
                            }}
                        />
                    </div>
                </div>

                <div className="info-text mBottom3x">
                    <span>
                        Per personalizzare la tua richiesta di prestito personale ti chiediamo di fornirci maggiori informazioni. 
                        {!isTableOccasional() ? (
                            <>
                        I valori di tan e taeg rimarranno espressi in range finché non avremo
                        preso in carico e valutato la tua richiesta.
                            </>
                        ) : (<></>)}
                    </span>
                </div>
                <p className="info-text in-focus">
                    TAEG{" "}
                    {Simulation.get("minTAEG") == Simulation.get("maxTAEG") ? (
                        <strong>{formatPercentage(Simulation.get("maxTAEG"))} </strong>
                    ) : (
                        <>
                            da <strong>{formatPercentage(Simulation.get("minTAEG"))}</strong> a <strong>{formatPercentage(Simulation.get("maxTAEG"))}</strong>
                        </>
                    )}
                </p>
                <br />

                {isModalMoreInfoActive && <Modal name="moreInfo" id="moreInfo" title="" description="" noHeader={true} isModalActive={isModalMoreInfoActive} closeModalOnClick={handleCloseModal} />}
                
                <Button label="continua" uppercase="yes" withIcon="yes" positionIcon="right" customClasses="btn-mobile-fixed --animated-arrow" color="red" onClick={onSubmit} />
            </Form>
        </section>
    );
};
